import { render, staticRenderFns } from "./FancySelect.vue?vue&type=template&id=7bfa6552&"
import script from "./FancySelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./FancySelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FancySelect.vue?vue&type=style&index=0&id=7bfa6552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
